import { formatRoleName } from '../../../common';
import { createSchemaStatementHandler } from '../../createSchemaStatementHandler';
import { adminRoleName } from '../../utils';
export const createRoleStmtInstruction = `
####  Creating roles
- Syntax: \`create role <role_name>;\`
- Example: \`create role editor;\`
`;
export const stmtCreateRole = ({ roleName }) => {
    return `create role ${roleName};`;
};
export const stmtForHumanCreateRole = ({ roleName }) => {
    return `Create the role __${roleName}__.`;
};
export const createRoleHandler = createSchemaStatementHandler({
    type: 'create role',
    parse: line => {
        const match = /^create role (?<roleName>\w+)/.exec(line);
        return match?.groups
            ? {
                type: 'create role',
                roleName: formatRoleName(match.groups.roleName),
            }
            : null;
    },
    getHumanStmt: stmtForHumanCreateRole,
    apply: (stmt, builder) => {
        if (stmt.roleName === adminRoleName) {
            throw new Error(`Role ${stmt.roleName} is reserved. Admin role is automatically created and has all permissions. You can't modify it.`);
        }
        builder.updateSchema(it => {
            return it.createAclRole(stmt.roleName);
        });
    },
});
//# sourceMappingURL=CreateRoleStmt.js.map